let __timestamp = 0

export const getTimestamp = () => ++__timestamp
